import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import style from './style';

export default function CircularIndeterminate() {
    const classes = style();
  return (
    <Box sx={{ display: 'flex' }} className={classes.centerLoader}>
      <CircularProgress  />
    </Box>
  );
}